export default "__VITE_ASSET__BPkKQg3c__"